import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    window.webkit?.messageHandlers?.iOSApp?.postMessage(
      { name: "UpdatePathConfiguration" }
    )
  }
}
